import { useEffect } from 'react';

import { generalInformation } from '~constants';

export function usePageTitle(title: string, hideAppName: boolean = false) {
	useEffect(() => {
		const appName = generalInformation.AppName;
		const env = import.meta.env.VITE_APP_ENV;
		const titleParts = [];

		if (env !== undefined && env !== 'production') {
			titleParts.push(env.substring(0, 3));
		}
		if (!hideAppName) {
			titleParts.push(appName);
		}

		titleParts.push(title);

		document.title = titleParts.join(' - ');
	}, [title, hideAppName]);

	return title;
}
